import { __values } from "tslib";
import { ActionEntityType, } from '@office-start/action-types';
import { isSupportedApp } from './mosAppActionGates';
import { convertToHarmonyAction, convertToHarmonyActionGroup, convertToHarmonyIcon, convertToHarmonyIntent, generateHarmonyActionId, } from './mosAppActionUtils';
export var getMosAppActions = function (appDefinition, hubActionsConfig) {
    var actionsFromManifest = appDefinition.actions;
    var resolvedActions = actionsFromManifest &&
        getResolvedHarmonyAction(appDefinition, hubActionsConfig);
    return resolvedActions;
};
var getResolvedHarmonyAction = function (appDefinition, hubActionsConfig) {
    var e_1, _a;
    //TODO: add feature gate check to turn on/off each action
    if (!hubActionsConfig.featureGates.mosContentActionEnabled) {
        return undefined;
    }
    var contentActionsFromManifest = appDefinition.actions;
    if (!contentActionsFromManifest ||
        contentActionsFromManifest.length === 0 ||
        !isSupportedApp(appDefinition.id, hubActionsConfig.featureGates)) {
        return undefined;
    }
    var resolvedActions = [];
    var platform = hubActionsConfig.deviceInfo.isHwa ? 'Native' : 'Web';
    var _loop_1 = function (contentAction) {
        var resolved = {
            intent: convertToHarmonyIntent(contentAction.intent),
            entities: [{ type: ActionEntityType.Content }],
            metadata: {
                appId: appDefinition.id,
                groupId: convertToHarmonyActionGroup(contentAction.intent),
                name: contentAction.displayName,
                description: contentAction.description,
                id: generateHarmonyActionId(appDefinition.id, contentAction.id),
                icon: convertToHarmonyIcon(contentAction, appDefinition.largeImageUrl),
                //TODO: notificationOptions when design is finalized
            },
            officeActionCreator: function (content) {
                if (!(content.isOneDriveForBusinessFile ||
                    content.isSharePointFile) ||
                    !content.driveId ||
                    !content.docId ||
                    !content.fileName ||
                    !content.fileType) {
                    return undefined;
                }
                return convertToHarmonyAction({
                    appId: appDefinition.id,
                    contentAction: contentAction,
                    content: content,
                    platform: platform,
                });
            },
        };
        resolvedActions.push(resolved);
    };
    try {
        for (var contentActionsFromManifest_1 = __values(contentActionsFromManifest), contentActionsFromManifest_1_1 = contentActionsFromManifest_1.next(); !contentActionsFromManifest_1_1.done; contentActionsFromManifest_1_1 = contentActionsFromManifest_1.next()) {
            var contentAction = contentActionsFromManifest_1_1.value;
            _loop_1(contentAction);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (contentActionsFromManifest_1_1 && !contentActionsFromManifest_1_1.done && (_a = contentActionsFromManifest_1.return)) _a.call(contentActionsFromManifest_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return resolvedActions;
};
//# sourceMappingURL=getMosAppActions.js.map